import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GruposService {
  TOKEN = localStorage.getItem('token');
  
  constructor(private http: HttpClient) { }

  private authHeaders(): HttpHeaders {
    this.TOKEN = localStorage.getItem('token');
    return new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN || ''});
  }

  private buildParams(params?: any): HttpParams {
    let httpParams = new HttpParams();
    if (!params) {
      return httpParams;
    }
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return httpParams;
  }

  getGruposV2(params?: any): Observable<any[]>{
    const headers = this.authHeaders();
    return this.http.get<any[]>(environment.BASE_URL+"/api/grupos-v2/", {headers, params: this.buildParams(params)});
  }

  crearGrupoV2(data): Observable<any[]>{
    const headers = this.authHeaders();
    return this.http.post<any[]>(environment.BASE_URL+"/api/grupos-v2/", data, {headers});
  }

  actualizarGrupoV2(grupo: number, data): Observable<any[]>{
    const headers = this.authHeaders();
    return this.http.put<any[]>(environment.BASE_URL+`/api/grupos-v2/${grupo}/`, data, {headers});
  }

  eliminarGrupoV2(grupo: number): Observable<any[]>{
    const headers = this.authHeaders();
    return this.http.delete<any[]>(environment.BASE_URL+`/api/grupos-v2/${grupo}/`, {headers});
  }

  buscarCatalogoGrupos(catalogo: string, params?: any): Observable<any[]>{
    const headers = this.authHeaders();
    return this.http.get<any[]>(environment.BASE_URL+`/api/grupos-v2/catalogos/${catalogo}/`, {headers, params: this.buildParams(params)});
  }

  agregarGrupo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarGrupo/", data);
  }

  getGrupos(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getGrupos/", {headers});
  }

  getGruposNombre(): Observable<any[]>{
    return this.http.get<any[]>(environment.BASE_URL+"/api/getGruposNombre/");
  }

  getMiembros(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getMiembros/", data);
  }

  getDetalleGrupo(data): Observable<any[]>{
    console.log(data);
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getDetalleGrupo/", data);
  }

  getDatosGrupo(data): Observable<any[]>{
    console.log(data);
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getDatosGrupo/", data);
  }

  getEstolas(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getEstolas/");
  }

  getFondos(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getFondos/");
  }

  getEstatusGrupo(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getEstatusGrupo/");
  }

  getSesionesTematicas(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getSesionesTematicas/");
  }

  updateGrupo(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateGrupo/", data);
  }

  eliminarGrupo(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarGrupo/", data, {headers});
  }

  confirmarAvance(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/confirmarAvance/", data, {headers});
  }

  getDataDashboard(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getDataDashboard/", {headers});
  }

  getHojaEntregaGrupo(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getHojaEntregaGrupo/", data, {headers});
  }

  filtrarDashboard(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/filtrarDashboard/", data, {headers});
  }

  getMostSelectedPaquetesDashboard(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getMostSelectedPaquetesDashboard/", {headers});
  }

  getMostSelectedPaquetesDashboardFiltrados(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getMostSelectedPaquetesDashboardFiltrados/", data, {headers});
  }

  cerrarGrupo(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/cerrarGrupo/", data, {headers});
  }

  getGruposFiltro(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getGruposFiltro/", data, {headers});
  }

  getVendedores(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getVendedores/", {headers});
  }

  agregarFiestaGrupo(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarFiestaGrupo/", data, {headers});
  }

  getFiestaGrupo(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getFiestaGrupo/", data, {headers});
  }

  getFiestaGrupoCliente(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getFiestaGrupoCliente/", data, {headers});
  }

  eliminarFiestaGrupo(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarFiestaGrupo/", data, {headers});
  }

  agregarViajeGrupo(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarViajeGrupo/", data, {headers});
  }

  getViajesGrupo(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getViajesGrupo/", data, {headers});
  }

  eliminarViajeGrupo(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/eliminarViajeGrupo/", data, {headers});
  }

}
